import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { makeSchemaForAllDisabilities } from '../../../all-claims/utils/schemas';

const TreatedConditionsList = ({ selected }) => {
  const formData = useSelector(state => state.form?.data);
  const { properties = {} } = makeSchemaForAllDisabilities(formData || {});
  const names = Object.keys(properties)
    .filter(key => selected?.[key] === true)
    .map(key => properties[key].title);

  if (!names.length) return null;
  if (names.length === 1) return names[0];
  return (
    <ul>
      {names.map(name => (
        <li key={name}>{name}</li>
      ))}
    </ul>
  );
};

TreatedConditionsList.propTypes = {
  selected: PropTypes.object,
};

// The checkbox options are built from the claimed conditions at render time,
// so the platform confirmation field can't resolve their labels.
export const treatedConditionsConfirmationField = ({ formData }) => {
  if (!formData || !Object.values(formData).some(Boolean)) {
    return { data: null };
  }
  return { data: <TreatedConditionsList selected={formData} /> };
};
